"use client"

import * as React from "react"
import { Popover as PopoverPrimitive } from "@base-ui/react/popover"

import { cn } from "@/shared/lib/utils"

type PopoverSide = "top" | "right" | "bottom" | "left"
type PopoverAlign = "start" | "center" | "end"

function Popover(props: PopoverPrimitive.Root.Props) {
  return <PopoverPrimitive.Root {...props} />
}

function PopoverTrigger(props: PopoverPrimitive.Trigger.Props) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverContent({
  className,
  side = "bottom",
  align = "center",
  sideOffset = 6,
  showBackdrop = false,
  children,
  ...props
}: PopoverPrimitive.Popup.Props & {
  side?: PopoverSide
  align?: PopoverAlign
  sideOffset?: number
  showBackdrop?: boolean
}) {
  return (
    <PopoverPrimitive.Portal>
      {showBackdrop && (
        <PopoverPrimitive.Backdrop className="fixed inset-0 z-40" />
      )}
      <PopoverPrimitive.Positioner
        side={side}
        align={align}
        sideOffset={sideOffset}
        collisionPadding={12}
        className="isolate z-50"
      >
        <PopoverPrimitive.Popup
          data-slot="popover-content"
          className={cn(
            "min-w-[220px] origin-(--transform-origin) rounded-[10px] border-[0.5px] border-[var(--rule-strong)] bg-[var(--bg-card)] p-3 text-[var(--ink-1)] shadow-[var(--shadow-float)] duration-100 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
            className,
          )}
          {...props}
        >
          {children}
        </PopoverPrimitive.Popup>
      </PopoverPrimitive.Positioner>
    </PopoverPrimitive.Portal>
  )
}

export { Popover, PopoverTrigger, PopoverContent }
